<template>
  <main>
    <div class="container-fluid mt-3" style="max-width: 800px">
      <div class="row m-3" v-if="erro">
        <div class="col card my-2 badge-danger text-center p-3 text-uppercase mt-3">
          {{ erro }}
        </div>
      </div>

      <div class="row m-3" v-if="sucesso">
        <div class="col card my-2 badge-success text-center p-3 text-uppercase mt-3">
          {{ sucesso }}
        </div>
      </div>
      <div v-if="dadosConta">
        <div class="row mb-3 g-3 mt-3">
          <div class="col">
            <h5><strong>Dados da Conta</strong></h5>
            <div class="a-divider a-divider-break"></div>
          </div>
        </div>

        <div class="card px-5 pt-1 pb-5 shadow">
          <div class="row mb-3 g-3 mt-3">
            <div class="col">
              <h5><strong>Conta</strong></h5>
              <div class="a-divider a-divider-break"></div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4">
              <div class="row g-3">
                <img v-if="dadosConta.conta.qrcode" :src="dadosConta.conta.qrcode" />
              </div>
            </div>
            <div class="col-sm-8">
              <div class="row mb-3 g-3 mt-3">
                <div class="col">
                  <div class="form-check-inline">
                    <input disabled class="form-check-input " type="radio" name="tipo"
                      v-model="dadosConta.conta.contaTipo" value="PESSOA_FISICA">
                    <label class="form-check-label">
                      Conta Pessoa Física
                    </label>
                  </div>
                </div>
                <div class="col">
                  <div class="b-3 form-check-inline">
                    <input disabled class="form-check-input " type="radio" name="tipo"
                      v-model="dadosConta.conta.contaTipo" value="PESSOA_JURIDICA">
                    <label class="form-check-label">
                      Conta Pessoa Jurídica
                    </label>
                  </div>
                </div>
              </div>
              <div class="row mb-3 g-3">
                <div class="col-sm-6">
                  <label for="razaoSocial" class="form-label">Saldo Disponível</label>
                  <span class="form-control"> R$ {{ formatPrice(dadosConta.conta.saldoDisponivel) }}</span>
                </div>
                <div class="col-sm-6">
                  <label for="nomeFantasia" class="form-label">Saldo Cashback</label>
                  <span class="form-control"> R$ {{ formatPrice(dadosConta.conta.saldoDisponivelCashback) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <form @submit.prevent="salvar">
          <div class="row mb-3 g-3 mt-3" v-if="dadosConta.conta.contaTipo == 'PESSOA_JURIDICA'">
            <div class="col">
              <h5><strong>Dados da Empresa</strong></h5>
              <div class="a-divider a-divider-break"></div>
            </div>
          </div>
          <div class="card px-5 pt-3 pb-5 shadow" v-if="dadosConta.conta.contaTipo == 'PESSOA_JURIDICA'">
            <div>
              <div class="row mb-3 g-3 mt-3">
                <div class="col">
                  <h6><strong>Dados cadastro</strong></h6>
                  <div class="a-divider a-divider-break"></div>
                </div>
              </div>
              <div class="row mb-3 g-3">
                <div class="col-sm-6">
                  <label for="usuario" class="form-label">CNPJ</label>
                  <input disabled class="form-control" type="text" id="usuario" placeholder="000.000.000-00"
                    v-model="dadosConta.pessoaJuridica.cnpj" v-mask="['###.###.###-##', '##.###.###/####-##']"
                    required />
                </div>
                <div class="col-sm-6">
                  <label for="celular" class="form-label">Telefone</label>
                  <input class="form-control" type="tel" id="celular" v-model="dadosConta.pessoaJuridica.telefone"
                    v-mask="['(##) ####-####', '(##) #####-####']" placeholder="(00) 00000-0000" required />
                </div>
              </div>
              <div class="row mb-3 g-3">
                <div class="col-sm-6">
                  <label for="razaoSocial" class="form-label">Razão social</label>
                  <input class="form-control" type="text" id="razaoSocial"
                    v-model="dadosConta.pessoaJuridica.razaoSocial" required />
                </div>
                <div class="col-sm-6">
                  <label for="nomeFantasia" class="form-label">Nome Fantasia</label>
                  <input class="form-control" type="text" id="nomeFantasia"
                    v-model="dadosConta.pessoaJuridica.nomeFantasia" required />
                </div>
              </div>

              <div class="row mb-3 g-3 mt-3">
                <div class="col">
                  <h6><strong>Endereço (Opcional)</strong></h6>
                  <div class="a-divider a-divider-break"></div>
                </div>
              </div>
              <div class="row mb-3 g-3">
                <div class="col-sm-6">
                  <label for="enderecoCep" class="form-label">Informe o CEP</label>
                  <input @keyup.enter="getByCep('cepCobranca')" @blur="getByCep('cepCobranca')" class="form-control"
                    type="text" id="enderecoCep" placeholder="00000-00" v-model="dadosConta.pessoaJuridica.endereco.cep"
                    v-mask="['#####-###']" />
                  <small class="text-muted" v-if="loadingCep">
                    <span class="spinner-border spinner-border-sm"></span>
                    Buscando seu CEP
                    <span class="button-loader grey ml-2"></span>
                  </small>
                  <small class="text-muted" v-if="cepNaoLocalizado">CEP não localizado</small>
                </div>
                <div class="col-sm-6">
                  <label for="enderecoUf" class="form-label">UF</label>
                  <input disabled class="form-control" type="text" id="enderecoUf"
                    v-model="dadosConta.pessoaJuridica.endereco.estado" />
                </div>
              </div>
              <div class="row mb-3 g-3">
                <div class="col-sm-6">
                  <label for="enderecoCidade" class="form-label">Cidade</label>
                  <input disabled class="form-control" type="text" id="enderecoCidade"
                    v-model="dadosConta.pessoaJuridica.endereco.cidade" />
                </div>
                <div class="col-sm-6">
                  <label for="enderecoBairro" class="form-label">Bairro</label>
                  <input disabled class="form-control" type="text" id="enderecoBairro"
                    v-model="dadosConta.pessoaJuridica.endereco.bairro" />
                </div>
              </div>
              <div class="row mb-3 g-3">
                <div class="col-sm-6">
                  <label for="enderecoLogradouro" class="form-label">Endereço</label>
                  <input disabled class="form-control" type="text" id="enderecoLogradouro"
                    v-model="dadosConta.pessoaJuridica.endereco.endereco" />
                </div>
                <div class="col-sm-6">
                  <label for="enderecoNumero" class="form-label">Número</label>
                  <input class="form-control" type="text" id="enderecoNumero"
                    v-model="dadosConta.pessoaJuridica.endereco.numero" />
                </div>
              </div>
              <div class="row mb-3 g-3">
                <div class="col-sm-6">
                  <label for="enderecoComplemento" class="form-label">Complemento</label>
                  <input class="form-control" type="text" id="enderecoComplemento"
                    v-model="dadosConta.pessoaJuridica.endereco.complemento" />
                </div>
              </div>
            </div>
          </div>


          <div class="row mb-3 g-3 mt-3">
            <div class="col">
              <h5 v-if="dadosConta.conta.contaTipo == 'PESSOA_JURIDICA'"><strong> Dados do responsável</strong></h5>
              <h5 v-if="dadosConta.conta.contaTipo == 'PESSOA_FISICA'"><strong> Dados pessoais</strong></h5>
              <div class="a-divider a-divider-break"></div>
            </div>
          </div>
          <div class="card px-5 pt-3 pb-5 shadow">

            <div class="row mb-3 g-3 mt-3">
              <div class="col">
                <h6 v-if="dadosConta.conta.contaTipo == 'PESSOA_JURIDICA'"><strong>Dados pessoais</strong></h6>
                <h6 v-if="dadosConta.conta.contaTipo == 'PESSOA_FISICA'"><strong>Dados cadastro</strong></h6>
                <div class="a-divider a-divider-break"></div>
              </div>
            </div>
            <div class="row mb-3 g-3">
              <div class="col-sm-6">
                <label for="usuario" class="form-label">CPF</label>
                <input :disabled="dadosConta.conta.contaTipo == 'PESSOA_FISICA'" class="form-control" type="text"
                  id="usuario" placeholder="000.000.000-00" v-model="dadosConta.pessoa.cpf"
                  v-mask="['###.###.###-##', '##.###.###/####-##']" required />
              </div>
              <div class="col-sm-6">
                <label for="dataNascimento" class="form-label">Data de nascimento</label>
                <input class="form-control" v-model="dataNasc" placeholder="00/00/0000" id="dataNascimento"
                  format="DD/MM/YYYY" v-mask="'##/##/####'" required pattern=".{10}" @blur="validarData" />
              </div>
            </div>
            <div class="row mb-3 g-3">
              <div class="col-sm-6">
                <label for="nome" class="form-label">Nome</label>
                <input class="form-control" type="text" id="nome" placeholder="Nome" v-model="nome" required />
              </div>

              <div class="col-sm-6">
                <label for="nome" class="form-label">Sobrenome</label>
                <input class="form-control" type="text" id="nome" placeholder="Nome" v-model="sobreNome" required />
              </div>
            </div>

            <div class="row mb-3 g-3">
              <div class="col-sm-6">
                <label for="celular" class="form-label">Celular</label>
                <input class="form-control" type="tel" id="celular" v-model="dadosConta.pessoa.telefone.telefone"
                  v-mask="['(##) ####-####', '(##) #####-####']" placeholder="(00) 00000-0000" required />
              </div>
              <div class="col-sm-6">
                <label for="email" class="form-label">E-mail</label>
                <input class="form-control" type="text" id="email" placeholder="seu@email.com"
                  v-model="dadosConta.pessoa.email" required />
              </div>
            </div>

            <div class="row mb-3 g-3 mt-3">
              <div class="col">
                <h6><strong>Endereço (Opcional)</strong></h6>
                <div class="a-divider a-divider-break"></div>
              </div>
            </div>
            <div class="row mb-3 g-3">
              <div class="col-sm-6">
                <label for="enderecoCep" class="form-label">Informe o CEP</label>
                <input @keyup.enter="getByCep('cepCobranca')" @blur="getByCep('cepCobranca')" class="form-control"
                  type="text" id="enderecoCep" placeholder="00000-00" v-model="dadosConta.pessoa.endereco.cep"
                  v-mask="['#####-###']" />
                <small class="text-muted" v-if="loadingCep">
                  <span class="spinner-border spinner-border-sm"></span>
                  Buscando seu CEP
                  <span class="button-loader grey ml-2"></span>
                </small>
                <small class="text-muted" v-if="cepNaoLocalizado">CEP não localizado</small>
              </div>
              <div class="col-sm-6">
                <label for="enderecoUf" class="form-label">UF</label>
                <input disabled class="form-control" type="text" id="enderecoUf"
                  v-model="dadosConta.pessoa.endereco.estado" />
              </div>
            </div>
            <div class="row mb-3 g-3">
              <div class="col-sm-6">
                <label for="enderecoCidade" class="form-label">Cidade</label>
                <input disabled class="form-control" type="text" id="enderecoCidade"
                  v-model="dadosConta.pessoa.endereco.cidade" />
              </div>
              <div class="col-sm-6">
                <label for="enderecoBairro" class="form-label">Bairro</label>
                <input disabled class="form-control" type="text" id="enderecoBairro"
                  v-model="dadosConta.pessoa.endereco.bairro" />
              </div>
            </div>
            <div class="row mb-3 g-3">
              <div class="col-sm-6">
                <label for="enderecoLogradouro" class="form-label">Endereço</label>
                <input disabled class="form-control" type="text" id="enderecoLogradouro"
                  v-model="dadosConta.pessoa.endereco.endereco" />
              </div>
              <div class="col-sm-6">
                <label for="enderecoNumero" class="form-label">Número</label>
                <input class="form-control" type="text" id="enderecoNumero"
                  v-model="dadosConta.pessoa.endereco.numero" />
              </div>
            </div>
            <div class="row mb-3 g-3">
              <div class="col-sm-6">
                <label for="enderecoComplemento" class="form-label">Complemento</label>
                <input class="form-control" type="text" id="enderecoComplemento"
                  v-model="dadosConta.pessoa.endereco.complemento" />
              </div>
            </div>
          </div>
          <div class="row mb-3 g-3 mt-3">
            <div class="col">
              <h5><strong>Indicação (Opcional)</strong></h5>
              <div class="a-divider a-divider-break"></div>
            </div>
          </div>
          <div class="card px-5 pt-3 pb-5 shadow">
            <div class="row mb-3 g-3 mt-3">
              <div class="col">
                <h6><strong>Cupom</strong></h6>
                <div class="a-divider a-divider-break"></div>
              </div>
            </div>
            <div class="row mb-3 g-3">
              <div class="col-sm-6">
                <label for="codigoIndicacao" class="form-label">Código do Cupom</label>
                <input class="form-control " type="text" id="codigoIndicacao"
                  v-model="dadosConta.conta.codigoIndicacao" />

              </div>

              <div class="col-sm-6" v-if="dadosConta.conta.nomeIndicacao">
                <label for="codigoIndicacao" class="form-label">Indicado por:</label>
                <input disabled class="form-control " type="text" id="codigoIndicacao"
                  v-model="dadosConta.conta.nomeIndicacao" />
              </div>
            </div>
            <small>*Caso você tenha sido indicado por um amigo, informe aqui o código do cupom.</small>
          </div>
          <div class="mt-3 mb-5 px-3 col-12 d-flex flex-column flex-lg-row justify-content-between">
            <button class="btn btn_color_system px-5 mt-4 py-2" @click="$router.go(-1)">
              VOLTAR
            </button>
            <button class="btn btn_color_system py-2 px-5 mt-4" type="submit">
              SALVAR
            </button>
          </div>
        </form>
      </div>
    </div>
    <Loading v-if="loading"></Loading>
  </main>
</template>

<script>
// @ is an alias to /src
import { APIService } from "../APIService";
const apiService = new APIService();
import Loading from "@/components/Loading.vue";

export default {
  name: "Cadastrar",
  components: { Loading },
  data() {
    return {
      nome: "",
      sobreNome: "",
      dadosConta: { },
      codigo: "",
      loadingCep: false,
      cepNaoLocalizado: false,
      loading: false,
      erro: "",
      sucesso: "",
      dataNasc: ""
    };
  },
  mounted() {
    this.obterDados();
  },
  methods: {
    obterDados() {
      this.loading = true;
      apiService.dadosApp().then((res) => {
        if (res.pessoa && !res.pessoa.endereco) {
          res.pessoa.endereco = this.enderecoVazio();
        }

        if (res.pessoaJuridica && !res.pessoaJuridica.endereco) {
          res.pessoaJuridica.endereco = this.enderecoVazio();
        }

        this.dadosConta = res;
        this.nome = res.pessoa.nome.replace(/\s.+$/, "");
        this.sobreNome = res.pessoa.nome.replace(/^\w*\s/g, "");

        const dateSplit = this.dadosConta.pessoa.dataNascimento.split("-");
        this.dataNasc = `${dateSplit[2]}/${dateSplit[1]}/${dateSplit[0]}`;

        this.loading = false;
      }).catch(error => {
        if(error.response && error.response.data && error.response.data.title) {
          this.erro = error.response.data.title;
        }

        this.loading = false;
        window.scrollTo(0, 0);
      });
    },
    getByCep(isPessoaJuridica) {

      let cep = '';

      if (this.dadosConta.pessoa && !this.dadosConta.pessoa.endereco) {
          this.dadosConta.pessoa.endereco = this.enderecoVazio();
      }

      if (isPessoaJuridica) {
        cep = this.dadosConta.pessoaJuridica.endereco.cep;
      } else {
        cep = this.dadosConta.pessoa.endereco.cep;
      }
      if (cep) {
        this.cepNaoLocalizado = false;
        if (!this.loadingCep) {
          this.loadingCep = true;
          apiService
            .getCep(cep)
            .then(res => {
              if (res) {
                if (isPessoaJuridica) {
                  this.dadosConta.pessoaJuridica.endereco = res;
                } else {
                  cep = this.dadosConta.pessoa.endereco = res;
                }
                this.loadingCep = false;
              }
              else {
                this.loadingCep = false;
                this.cepNaoLocalizado = true;
              }
            })
            .catch(() => {
              this.loadingCep = false;
              this.cepNaoLocalizado = true;
            })
            .finally(() => {
              this.loadingCep = false;
            });
        }
      }
    },
    formatPrice(value) {
      let val = ((value || 0) / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    enderecoVazio() {
      return {
        cep: "",
        endereco: "",
        complemento: "",
        numero: "",
        bairro: "",
        cidade: "",
        estado: "",
        pais: "",
      };
    },
    salvar() {

      this.loading = true;
      this.erro = "";
      this.sucesso = "";
      this.dadosConta.pessoa.nome = `${this.nome.trim()} ${this.sobreNome.trim()}`;

      const dateSplit = this.dataNasc.split("/");
      this.dadosConta.pessoa.dataNascimento = `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`;

      apiService
        .atualizarConta(this.dadosConta)
        .then(() => {
          this.sucesso = "Dados atualizados com sucesso.";
          this.loading = false;
          window.scrollTo(0, 0);
        })
        .catch(error => {
          this.erro = error.response.data.title;
          this.loading = false;
          window.scrollTo(0, 0);
        });
    },
    validarData() {
      if (!this.$moment(this.dataNasc, "DD/MM/YYYY").isValid())
        this.dataNasc = "";
    },
    removeMask(n) {
      return n.replace(/\D/gm, "");
    }
  }
};
</script>
<style scoped lang="scss">
button {
  background: var(--cor-principal);
  color: var(--cor-texto);
}

.a-divider.a-divider-break {
  text-align: center;
  position: relative;
  top: 2px;
  padding-top: 1px;
  margin-bottom: 14px;
  line-height: 0;

  &:after {
    content: "";
    width: 100%;
    background-color: transparent;
    display: block;
    height: 1px;
    border-top: 1px solid var(--cor-secundaria);
    position: absolute;
    top: 50%;
    margin-top: -1px;
    z-index: 1;
  }

  h5 {
    line-height: 1;
    font-size: 12px;
    color: #767676;
    font-weight: 400;
    z-index: 2;
    position: relative;
    display: inline-block;
    background-color: #fff;
    padding: 0 8px 0 7px;
  }
}
</style>
